// ── Clip Configuration System ─────────────────────────────────────────────────

export type ClipSection = 'operator-react' | 'kill-react' | 'scenarios';
export type WeaponGroup = 'Vandal' | 'Phantom';

export interface TriggerMoment {
  triggerTime: number;
  label?: string;
}

export interface ClipConfig {
  id: string;
  src: string;
  section: ClipSection;
  triggers: TriggerMoment[];
  label: string;
  fps?: number;
  /** For kill-react: which weapon group this clip belongs to */
  group?: WeaponGroup;
}

// ── Kill Scenarios — Vandal ───────────────────────────────────────────────────
export const VANDAL_CLIPS: ClipConfig[] = [
  {
    id: 'v-1', label: '1v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/0qod57',
    triggers: [
      { triggerTime: 1.025299, label: 'Trigger 1' },
      { triggerTime: 1.615329, label: 'Trigger 2' },
      { triggerTime: 3.145117, label: 'Trigger 3' },
      { triggerTime: 4.240524, label: 'Trigger 4' },
      { triggerTime: 5.566104, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-2', label: '2v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/9g24j5',
    triggers: [
      { triggerTime: 0.932388, label: 'Trigger 1' },
      { triggerTime: 1.921700, label: 'Trigger 2' },
      { triggerTime: 2.765726, label: 'Trigger 3' },
      { triggerTime: 3.513549, label: 'Trigger 4' },
      { triggerTime: 5.720754, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-3', label: '3v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/rv0tlc',
    triggers: [
      { triggerTime: 1.018028, label: 'Trigger 1' },
      { triggerTime: 1.642294, label: 'Trigger 2' },
      { triggerTime: 2.763683, label: 'Trigger 3' },
      { triggerTime: 3.484530, label: 'Trigger 4' },
      { triggerTime: 4.544313, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-4', label: '4v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/5nzofe',
    triggers: [
      { triggerTime: 0.915828, label: 'Trigger 1' },
      { triggerTime: 1.835580, label: 'Trigger 2' },
      { triggerTime: 3.196789, label: 'Trigger 3' },
      { triggerTime: 4.237476, label: 'Trigger 4' },
      { triggerTime: 7.377868, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-5', label: '5v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/9l2x3u',
    triggers: [
      { triggerTime: 0.882627, label: 'Trigger 1' },
      { triggerTime: 1.646790, label: 'Trigger 2' },
      { triggerTime: 2.333355, label: 'Trigger 3' },
      { triggerTime: 3.241636, label: 'Trigger 4' },
      { triggerTime: 6.709427, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-6', label: '6v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/ckqxhv',
    triggers: [
      { triggerTime: 0.436080, label: 'Trigger 1' },
      { triggerTime: 1.140671, label: 'Trigger 2' },
      { triggerTime: 2.128119, label: 'Trigger 3' },
      { triggerTime: 4.093975, label: 'Trigger 4' },
      { triggerTime: 5.794318, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-7', label: '7v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/vzccne',
    triggers: [
      { triggerTime: 0.783335, label: 'Trigger 1' },
      { triggerTime: 1.317957, label: 'Trigger 2' },
      { triggerTime: 2.591208, label: 'Trigger 3' },
      { triggerTime: 3.151099, label: 'Trigger 4' },
      { triggerTime: 5.465849, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-8', label: '8v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/sw3uwj',
    triggers: [
      { triggerTime: 0.622017, label: 'Trigger 1' },
      { triggerTime: 2.186684, label: 'Trigger 2' },
      { triggerTime: 3.146847, label: 'Trigger 3' },
      { triggerTime: 4.144849, label: 'Trigger 4' },
      { triggerTime: 7.260845, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-9', label: '9v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/rfw27d',
    triggers: [
      { triggerTime: 0.852479, label: 'Trigger 1' },
      { triggerTime: 1.376998, label: 'Trigger 2' },
      { triggerTime: 2.158756, label: 'Trigger 3' },
      { triggerTime: 3.626568, label: 'Trigger 4' },
      { triggerTime: 6.745397, label: 'Trigger 5' },
    ],
  },
  {
    id: 'v-10', label: '10v', section: 'operator-react', group: 'Vandal',
    src: 'https://streamable.com/e/a6o3xd',
    triggers: [
      { triggerTime: 0.299995, label: 'Trigger 1' },
      { triggerTime: 1.005843, label: 'Trigger 2' },
      { triggerTime: 1.865902, label: 'Trigger 3' },
      { triggerTime: 2.621993, label: 'Trigger 4' },
      { triggerTime: 3.666988, label: 'Trigger 5' },
    ],
  },
];

// ── Kill Scenarios — Phantom ──────────────────────────────────────────────────
export const PHANTOM_CLIPS: ClipConfig[] = [
  {
    id: 'p-1', label: '1p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/wmtvi1',
    triggers: [
      { triggerTime: 0.586586, label: 'Trigger 1' },
      { triggerTime: 2.020532, label: 'Trigger 2' },
      { triggerTime: 2.722346, label: 'Trigger 3' },
      { triggerTime: 3.728885, label: 'Trigger 4' },
      { triggerTime: 4.813616, label: 'Trigger 5' },
    ],
  },
  {
    id: 'p-2', label: '2p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/e8r4fy',
    triggers: [
      { triggerTime: 0.987532, label: 'Trigger 1' },
      { triggerTime: 1.744253, label: 'Trigger 2' },
      { triggerTime: 2.589871, label: 'Trigger 3' },
      { triggerTime: 3.728903, label: 'Trigger 4' },
      { triggerTime: 9.074410, label: 'Trigger 5' },
    ],
  },
  {
    id: 'p-3', label: '3p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/gnxg20',
    triggers: [
      { triggerTime: 0.623784, label: 'Trigger 1' },
      { triggerTime: 1.245443, label: 'Trigger 2' },
      { triggerTime: 3.014495, label: 'Trigger 3' },
      { triggerTime: 5.107180, label: 'Trigger 4' },
      { triggerTime: 6.040387, label: 'Trigger 5' },
    ],
  },
  {
    id: 'p-4', label: '4p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/hmqapr',
    triggers: [
      { triggerTime: 1.193355, label: 'Trigger 1' },
      { triggerTime: 1.852185, label: 'Trigger 2' },
      { triggerTime: 2.484109, label: 'Trigger 3' },
      { triggerTime: 4.549433, label: 'Trigger 4' },
      { triggerTime: 5.475761, label: 'Trigger 5' },
    ],
  },
  {
    id: 'p-5', label: '5p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/if64yr',
    triggers: [
      { triggerTime: 0.628518, label: 'Trigger 1' },
      { triggerTime: 1.062555, label: 'Trigger 2' },
      { triggerTime: 2.158336, label: 'Trigger 3' },
      { triggerTime: 2.577787, label: 'Trigger 4' },
      { triggerTime: 3.580802, label: 'Trigger 5' },
    ],
  },
  {
    id: 'p-6', label: '6p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/8edlj7',
    triggers: [
      { triggerTime: 0.936573, label: 'Trigger 1' },
      { triggerTime: 1.689266, label: 'Trigger 2' },
      { triggerTime: 2.400676, label: 'Trigger 3' },
      { triggerTime: 3.689016, label: 'Trigger 4' },
      { triggerTime: 5.025952, label: 'Trigger 5' },
    ],
  },
  {
    id: 'p-7', label: '7p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/catujm',
    triggers: [
      { triggerTime: 0.321133, label: 'Trigger 1' },
      { triggerTime: 0.887794, label: 'Trigger 2' },
      { triggerTime: 1.818176, label: 'Trigger 3' },
      { triggerTime: 2.953496, label: 'Trigger 4' },
      { triggerTime: 3.665469, label: 'Trigger 5' },
    ],
  },
  {
    id: 'p-8', label: '8p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/gmxbxs',
    triggers: [
      { triggerTime: 0.810465, label: 'Trigger 1' },
      { triggerTime: 1.555783, label: 'Trigger 2' },
      { triggerTime: 2.223796, label: 'Trigger 3' },
      { triggerTime: 3.140417, label: 'Trigger 4' },
      { triggerTime: 5.552234, label: 'Trigger 5' },
    ],
  },
  {
    id: 'p-9', label: '9p', section: 'operator-react', group: 'Phantom',
    src: 'https://streamable.com/e/3icw2p',
    triggers: [
      { triggerTime: 0.917718, label: 'Trigger 1' },
      { triggerTime: 1.649514, label: 'Trigger 2' },
      { triggerTime: 2.690766, label: 'Trigger 3' },
      { triggerTime: 4.363938, label: 'Trigger 4' },
      { triggerTime: 5.600349, label: 'Trigger 5' },
    ],
  },
];

// ── All Kill Scenarios clips (flat, ordered by group) ─────────────────────────
export const OPERATOR_REACT_CLIPS: ClipConfig[] = [
  ...VANDAL_CLIPS,
  ...PHANTOM_CLIPS,
];

// ── Kill React (legacy alias) ─────────────────────────────────────────────────
export const KILL_REACT_CLIPS: ClipConfig[] = OPERATOR_REACT_CLIPS;

// ── Esport Scenarios ──────────────────────────────────────────────────────────
export const SCENARIOS_CLIPS: ClipConfig[] = [
  {
    id: 'e-1', label: '1e', section: 'scenarios',
    src: 'https://streamable.com/e/ghrfkg',
    triggers: [
      { triggerTime: 1.092324, label: 'Trigger 1' },
      { triggerTime: 1.857777, label: 'Trigger 2' },
      { triggerTime: 5.320945, label: 'Trigger 3' },
    ],
  },
  {
    id: 'e-2', label: '2e', section: 'scenarios',
    src: 'https://streamable.com/e/vlw514',
    triggers: [
      { triggerTime: 0.595777, label: 'Trigger 1' },
      { triggerTime: 2.512818, label: 'Trigger 2' },
      { triggerTime: 4.868976, label: 'Trigger 3' },
    ],
  },
  {
    id: 'e-3', label: '3e', section: 'scenarios',
    src: 'https://streamable.com/e/rmm3f5',
    triggers: [
      { triggerTime: 2.053561, label: 'Trigger 1' },
      { triggerTime: 2.952459, label: 'Trigger 2' },
      { triggerTime: 3.769451, label: 'Trigger 3' },
      { triggerTime: 4.436471, label: 'Trigger 4' },
      { triggerTime: 7.927758, label: 'Trigger 5' },
    ],
  },
  {
    id: 'e-4', label: '4e', section: 'scenarios',
    src: 'https://streamable.com/e/16lsmh',
    triggers: [
      { triggerTime: 0.637234, label: 'Trigger 1' },
      { triggerTime: 3.210447, label: 'Trigger 2' },
      { triggerTime: 5.311358, label: 'Trigger 3' },
      { triggerTime: 6.379580, label: 'Trigger 4' },
      { triggerTime: 8.894553, label: 'Trigger 5' },
    ],
  },
  {
    id: 'e-5', label: '5e', section: 'scenarios',
    src: 'https://streamable.com/e/c2llh3',
    triggers: [
      { triggerTime: 1.572827, label: 'Trigger 1' },
      { triggerTime: 2.776056, label: 'Trigger 2' },
      { triggerTime: 4.767569, label: 'Trigger 3' },
      { triggerTime: 7.214487, label: 'Trigger 4' },
    ],
  },
  {
    id: 'e-6', label: '6e', section: 'scenarios',
    src: 'https://streamable.com/e/c3nxrx',
    triggers: [
      { triggerTime: 1.551210, label: 'Trigger 1' },
      { triggerTime: 3.554181, label: 'Trigger 2' },
      { triggerTime: 4.836613, label: 'Trigger 3' },
      { triggerTime: 6.008371, label: 'Trigger 4' },
      { triggerTime: 7.280264, label: 'Trigger 5' },
      { triggerTime: 7.963780, label: 'Trigger 6' },
    ],
  },
  {
    id: 'e-7', label: '7e', section: 'scenarios',
    src: 'https://streamable.com/e/qu7k8z',
    triggers: [
      { triggerTime: 1.122274, label: 'Trigger 1' },
      { triggerTime: 3.063291, label: 'Trigger 2' },
      { triggerTime: 6.559869, label: 'Trigger 3' },
      { triggerTime: 7.012114, label: 'Trigger 4' },
      { triggerTime: 7.937034, label: 'Trigger 5' },
      { triggerTime: 9.182198, label: 'Trigger 6' },
    ],
  },
];

// ── Reaction window thresholds (ms) ──────────────────────────────────────────
export const REACTION_WINDOW_MS = 600;
export const PERFECT_MAX_MS = 150;
export const GOOD_MIN_MS = 250;
export const GOOD_MAX_MS = 400;
// 400–600ms = Okay

export type ReactionOutcome = 'perfect' | 'good' | 'okay' | 'too-early' | 'too-late';

export function classifyReaction(ms: number): ReactionOutcome {
  if (ms <= 0) return 'too-early';
  if (ms <= PERFECT_MAX_MS) return 'perfect';
  if (ms <= GOOD_MAX_MS) return 'good';
  if (ms <= REACTION_WINDOW_MS) return 'okay';
  return 'too-late';
}
